// Ancient Japan Trainers Data - Group Two (Characters 7-12)

// Zen Monk Master's workout programs
const zenMonkPrograms = [
    {
        id: 'enlightened-conditioning',
        name: 'Enlightened Conditioning',
        description: 'Perfect balance of body and mind through meditative movement',
        pattern: 'a@d_w^',
        reps: 5,
        sets: 8,
        focus: 'Mindful Balance'
    },
    {
        id: 'temple-guardian-training',
        name: 'Temple Guardian Training',
        description: 'Protective strength developed through daily temple duties',
        pattern: '@dwa_^',
        reps: 12,
        sets: 4,
        focus: 'Sacred Protection'
    },
    {
        id: 'meditation-in-motion',
        name: 'Meditation in Motion',
        description: 'Moving meditation that builds inner and outer strength',
        pattern: 'd_@aw^',
        reps: 21,
        sets: 3,
        focus: 'Moving Meditation'
    },
    {
        id: 'compassionate-warrior-workout',
        name: 'Compassionate Warrior Workout',
        description: 'Gentle strength that protects without causing harm',
        pattern: 'wa@d_^',
        reps: 16,
        sets: 4,
        focus: 'Compassionate Power'
    },
    {
        id: 'mountain-monastery-conditioning',
        name: 'Mountain Monastery Conditioning',
        description: 'High-altitude training for elevated consciousness',
        pattern: '^_adw@',
        reps: 9,
        sets: 6,
        focus: 'Elevated Training'
    },
    {
        id: 'path-to-enlightenment-protocol',
        name: 'Path to Enlightenment Protocol',
        description: 'The complete journey from physical to spiritual mastery',
        pattern: 'a@d_w^!',
        reps: 18,
        sets: 3,
        focus: 'Spiritual Mastery'
    }
];

// Fuma Kotaro's workout programs
const fumaKotaroPrograms = [
    {
        id: 'giant-ninja-training',
        name: 'Giant Ninja Training',
        description: 'Massive power hidden within shadow arts and stealth',
        pattern: '~^@wd_',
        reps: 27,
        sets: 3,
        focus: 'Hidden Giant Power'
    },
    {
        id: 'bandits-leader-conditioning',
        name: 'Bandit Leader Conditioning',
        description: 'Guerrilla warfare training for unconventional combat',
        pattern: '^~_@dw',
        reps: 23,
        sets: 4,
        focus: 'Guerrilla Leadership'
    },
    {
        id: 'mountain-warfare-workout',
        name: 'Mountain Warfare Workout',
        description: 'Terrain mastery for fighting in any environment',
        pattern: '@~^wd_',
        reps: 19,
        sets: 5,
        focus: 'Terrain Mastery'
    },
    {
        id: 'clan-destroyer-protocol',
        name: 'Clan Destroyer Protocol',
        description: 'Overwhelming force that breaks enemy formations',
        pattern: 'w@~^_d',
        reps: 31,
        sets: 3,
        focus: 'Formation Breaking'
    },
    {
        id: 'supernatural-strength-training',
        name: 'Supernatural Strength Training',
        description: 'Training that transcends normal human limitations',
        pattern: '_d@~^w',
        reps: 25,
        sets: 4,
        focus: 'Supernatural Power'
    },
    {
        id: 'feared-leader-mastery',
        name: 'Feared Leader Mastery',
        description: 'The complete training of Japan\'s most terrifying ninja clan leader',
        pattern: '~^@wd_!',
        reps: 29,
        sets: 3,
        focus: 'Terrifying Leadership'
    }
];

// Sumo Grand Champion's workout programs
const sumoChampionPrograms = [
    {
        id: 'earth-shaking-conditioning',
        name: 'Earth Shaking Conditioning',
        description: 'Massive power training that moves immovable objects',
        pattern: '~=qy[<',
        reps: 6,
        sets: 5,
        focus: 'Seismic Power'
    },
    {
        id: 'sacred-ring-training',
        name: 'Sacred Ring Training',
        description: 'Traditional sumo conditioning with ceremonial strength',
        pattern: '=~[qy<',
        reps: 8,
        sets: 4,
        focus: 'Sacred Strength'
    },
    {
        id: 'yokozuna-excellence-workout',
        name: 'Yokozuna Excellence Workout',
        description: 'Grand champion training for ultimate sumo mastery',
        pattern: '[~=<qy',
        reps: 10,
        sets: 6,
        focus: 'Grand Championship'
    },
    {
        id: 'mountain-mover-protocol',
        name: 'Mountain Mover Protocol',
        description: 'Legendary strength that can move mountains',
        pattern: 'q=~y[<',
        reps: 4,
        sets: 8,
        focus: 'Legendary Might'
    },
    {
        id: 'unshakeable-foundation-training',
        name: 'Unshakeable Foundation Training',
        description: 'Root-like stability that cannot be moved or toppled',
        pattern: '<qy=~[',
        reps: 12,
        sets: 3,
        focus: 'Immovable Foundation'
    },
    {
        id: 'ultimate-sumo-mastery',
        name: 'Ultimate Sumo Mastery',
        description: 'The complete path to becoming an unstoppable force',
        pattern: '~=qy[<!',
        reps: 15,
        sets: 4,
        focus: 'Unstoppable Force'
    }
];

// Yamabushi Mountain Ascetic's workout programs
const yamabushiPrograms = [
    {
        id: 'mountain-spirit-training',
        name: 'Mountain Spirit Training',
        description: 'Harness the raw power of mountain peaks and flowing streams',
        pattern: 'c~l@rb',
        reps: 13,
        sets: 7,
        focus: 'Mountain Spirit'
    },
    {
        id: 'hermit-warrior-conditioning',
        name: 'Hermit Warrior Conditioning',
        description: 'Solitary training that builds both mystical and physical power',
        pattern: 'l@~crb',
        reps: 17,
        sets: 3,
        focus: 'Hermit Power'
    },
    {
        id: 'elemental-mastery-workout',
        name: 'Elemental Mastery Workout',
        description: 'Training that connects with earth, water, fire, and air',
        pattern: '@clbr~',
        reps: 11,
        sets: 6,
        focus: 'Elemental Control'
    },
    {
        id: 'supernatural-endurance-protocol',
        name: 'Supernatural Endurance Protocol',
        description: 'Transcendent conditioning that goes beyond human limits',
        pattern: 'rb@~cl',
        reps: 33,
        sets: 2,
        focus: 'Transcendent Endurance'
    },
    {
        id: 'mountain-peak-ascension',
        name: 'Mountain Peak Ascension',
        description: 'Vertical training that conquers the highest peaks',
        pattern: '~cbrl@',
        reps: 21,
        sets: 4,
        focus: 'Peak Conquest'
    },
    {
        id: 'mystic-mountain-mastery',
        name: 'Mystic Mountain Mastery',
        description: 'The complete training of supernatural mountain warriors',
        pattern: 'c~l@rb!',
        reps: 27,
        sets: 3,
        focus: 'Mystic Mastery'
    }
];

// Prince Shotoku's workout programs
const princeShotokuPrograms = [
    {
        id: 'constitutional-conditioning',
        name: 'Constitutional Conditioning',
        description: 'Balanced training that builds both wisdom and physical strength',
        pattern: '_da@w^',
        reps: 17,
        sets: 4,
        focus: 'Constitutional Balance'
    },
    {
        id: 'diplomatic-warrior-training',
        name: 'Diplomatic Warrior Training',
        description: 'Peaceful strength that commands respect without aggression',
        pattern: 'ad@_w^',
        reps: 14,
        sets: 5,
        focus: 'Diplomatic Strength'
    },
    {
        id: 'scholarly-strength-workout',
        name: 'Scholarly Strength Workout',
        description: 'Intellectual pursuits combined with physical conditioning',
        pattern: 'w@^_da',
        reps: 12,
        sets: 6,
        focus: 'Scholar Warrior'
    },
    {
        id: 'temple-builder-protocol',
        name: 'Temple Builder Protocol',
        description: 'Construction-focused training for building lasting institutions',
        pattern: '^_@wad',
        reps: 16,
        sets: 4,
        focus: 'Institution Building'
    },
    {
        id: 'future-vision-conditioning',
        name: 'Future Vision Conditioning',
        description: 'Forward-thinking training that prepares for coming challenges',
        pattern: 'da^@w_',
        reps: 20,
        sets: 3,
        focus: 'Future Preparation'
    },
    {
        id: 'regent-excellence-mastery',
        name: 'Regent Excellence Mastery',
        description: 'The complete training of wise leadership and benevolent rule',
        pattern: '_da@w^!',
        reps: 18,
        sets: 4,
        focus: 'Wise Leadership'
    }
];

// Tengu Master's workout programs
const tenguMasterPrograms = [
    {
        id: 'mountain-demon-training',
        name: 'Mountain Demon Training',
        description: 'Supernatural swordsmanship that transcends human limitations',
        pattern: '^h*&es',
        reps: 9,
        sets: 9,
        focus: 'Supernatural Swordsmanship'
    },
    {
        id: 'wind-walker-conditioning',
        name: 'Wind Walker Conditioning',
        description: 'Aerial agility training for moving through mountain peaks',
        pattern: 'h^s*e&',
        reps: 15,
        sets: 5,
        focus: 'Aerial Mastery'
    },
    {
        id: 'sword-sage-workout',
        name: 'Sword Sage Workout',
        description: 'Ancient wisdom combined with perfect martial technique',
        pattern: '*&^hse',
        reps: 7,
        sets: 7,
        focus: 'Sword Wisdom'
    },
    {
        id: 'mystical-mentor-protocol',
        name: 'Mystical Mentor Protocol',
        description: 'Teaching-focused training that demonstrates perfect form',
        pattern: 'se&*^h',
        reps: 11,
        sets: 6,
        focus: 'Perfect Instruction'
    },
    {
        id: 'feathered-warrior-training',
        name: 'Feathered Warrior Training',
        description: 'Light-as-air movement with crushing supernatural power',
        pattern: '&hs^*e',
        reps: 13,
        sets: 4,
        focus: 'Feathered Power'
    },
    {
        id: 'legendary-tengu-mastery',
        name: 'Legendary Tengu Mastery',
        description: 'The complete training of Japan\'s greatest supernatural teachers',
        pattern: '^h*&es!',
        reps: 19,
        sets: 3,
        focus: 'Supernatural Teaching'
    }
];

// Main Ancient Japan trainers data object - Group Two
const japanTwoTrainersData = {
    'zen-monk-master': {
        id: 'zen-monk-master',
        name: 'Zen Monk Master',
        specialization: 'Enlightened Movement & Spiritual Conditioning',
        image: '/assets/images/zen-monk.jpg',
        experience: '60+ years',
        category: 'ancient-japan',
        color: '#8B4513',
        secondaryColor: '#F5DEB3',
        intro: `The Zen Monk Master has achieved perfect balance between physical strength and spiritual enlightenment. Through decades of meditation and temple duties, he teaches that true power comes from inner peace and mindful movement. Every exercise becomes a meditation, every breath a prayer for strength.`,
        programs: zenMonkPrograms
    },
    'fuma-kotaro': {
        id: 'fuma-kotaro',
        name: 'Fuma Kotaro',
        specialization: 'Giant Ninja Combat & Guerrilla Leadership',
        image: '/assets/images/fuma-kotaro.jpg',
        experience: '45+ years',
        category: 'ancient-japan',
        color: '#2F4F4F',
        secondaryColor: '#8B0000',
        intro: `Leader of the most feared ninja clan in Japan, Fuma Kotaro combines massive physical presence with supernatural stealth abilities. His mountain bandit training creates warriors who can disappear like mist yet strike with the force of avalanches. Students learn that true power often comes from the most unexpected sources.`,
        programs: fumaKotaroPrograms
    },
    'sumo-grand-champion': {
        id: 'sumo-grand-champion',
        name: 'Sumo Grand Champion',
        specialization: 'Sacred Strength & Immovable Power',
        image: '/assets/images/sumo-champion.jpg',
        experience: '35+ years',
        category: 'ancient-japan',
        color: '#DAA520',
        secondaryColor: '#8B4513',
        intro: `The Yokozuna represents the pinnacle of sumo achievement, combining massive physical power with spiritual purity and ceremonial grace. His training builds not just strength, but the sacred responsibility that comes with wielding such overwhelming force. True champions protect rather than dominate.`,
        programs: sumoChampionPrograms
    },
    'yamabushi-mountain-ascetic': {
        id: 'yamabushi-mountain-ascetic',
        name: 'Yamabushi Mountain Ascetic',
        specialization: 'Elemental Training & Supernatural Endurance',
        image: '/assets/images/yamabushi.jpg',
        experience: '50+ years',
        category: 'ancient-japan',
        color: '#556B2F',
        secondaryColor: '#CD853F',
        intro: `Living in harmony with the raw forces of nature, the Yamabushi has transcended normal human limitations through mystical mountain training. His conditioning connects students with elemental powers - the stability of earth, the flow of water, the intensity of fire, and the freedom of wind.`,
        programs: yamabushiPrograms
    },
    'prince-shotoku': {
        id: 'prince-shotoku',
        name: 'Prince Shotoku',
        specialization: 'Constitutional Wisdom & Balanced Development',
        image: '/assets/images/prince-shotoku.jpg',
        experience: '49+ years',
        category: 'ancient-japan',
        color: '#4B0082',
        secondaryColor: '#FFD700',
        intro: `The wise prince regent who established Japan's first constitution understood that lasting strength requires both physical conditioning and intellectual development. His training builds leaders who can command through wisdom rather than force, creating harmony between body, mind, and spirit.`,
        programs: princeShotokuPrograms
    },
    'tengu-master': {
        id: 'tengu-master',
        name: 'Tengu Master',
        specialization: 'Supernatural Swordsmanship & Mountain Mastery',
        image: '/assets/images/tengu-master.jpg',
        experience: '500+ years',
        category: 'ancient-japan',
        color: '#8B0000',
        secondaryColor: '#F5F5DC',
        intro: `The legendary mountain spirit who taught swordsmanship to Japan's greatest warriors. With supernatural agility and otherworldly strength, the Tengu Master reveals training methods that transcend human limitations. Students learn that mastery comes not from force, but from perfect harmony with natural law.`,
        programs: tenguMasterPrograms
    }
};

// Export the data
export default japanTwoTrainersData;